import styled from 'styled-components'
import { ANATOMY_V2_ACCENT_COLOR } from '~/pages/anatomyV2/libs/constants'
import { COLORS } from '~/shared/constants/uiConstants'

export const OptionButton = styled.button<{ $isSelected?: boolean }>`
  width: 100%;
  padding: 16px;
  border-radius: 14px;
  border: 1.5px solid
    ${({ $isSelected }) =>
      $isSelected ? ANATOMY_V2_ACCENT_COLOR : COLORS.GRAY_400};
  background: ${({ $isSelected }) => ($isSelected ? '#EDE7FE' : COLORS.WHITE)};
  font-size: 15px;
  font-weight: 600;
  color: ${COLORS.BLACK};
  text-align: left;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  touch-action: manipulation;

  &:not(:last-of-type) {
    margin-bottom: 12px;
  }

  &:active {
    background: ${({ $isSelected }) =>
      $isSelected ? '#EDE7FE' : COLORS.WHITE};
  }
`
